import React, { useState, useEffect } from "react";
import axios from "axios";
import parse from "html-react-parser";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFilePdf } from "@fortawesome/free-solid-svg-icons";
import { FadeLoader } from "react-spinners";

const OdsijekDetalj = () => {
  const { id } = useParams();
  const { t } = useTranslation();
  const storedLanguage = localStorage.getItem("selectedLanguage");

  const [odsjek, setOdsjek] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    setLoading(true);
    setError(null);

    axios
      .get("https://www.asu.unsa.ba/v2/index.php", {
        params: {
          rest_route: `/wp/v2/pages/${id}`,
          _embed: true,
          _fields: "id,title,content,acf,_embedded",
          acf_format: "standard",
        },
      })
      .then((res) => {
        setOdsjek(res.data);
      })
      .catch((err) => {
        console.error(
          "API error:",
          err?.response?.status,
          err?.response?.data || err?.message
        );
        setError("Podaci nisu dostupni.");
        setOdsjek(null);
      })
      .finally(() => setLoading(false));
  }, [id]);

  if (loading) {
    return (
      <div
        className="text-center"
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "70vh",
        }}
      >
        <FadeLoader color="#123abc" />
      </div>
    );
  }

  if (error || !odsjek) {
    return <p style={{ padding: 20 }}>{error || "Podaci nisu dostupni."}</p>;
  }

  const naslov =
    storedLanguage === "en"
      ? odsjek?.acf?.prevod_naslova || odsjek?.title?.rendered || ""
      : odsjek?.title?.rendered || "";

  const opis =
    storedLanguage === "en"
      ? odsjek?.acf?.prevod_teksta || odsjek?.content?.rendered || ""
      : odsjek?.content?.rendered || "";

  const prikaziOpis = {
    replace: (domNode) => {
      if (
        domNode?.name === "a" &&
        domNode?.attribs?.href &&
        domNode.attribs.href.toLowerCase().endsWith(".pdf")
      ) {
        return (
          <a
            href={domNode.attribs.href}
            target="_blank"
            rel="noopener noreferrer"
          >
            <FontAwesomeIcon icon={faFilePdf} style={{ marginRight: 6 }} />
            {domNode?.children?.[0]?.data || "PDF"}
          </a>
        );
      }
      return null;
    },
  };

  const backgroundImageUrl =
    odsjek?._embedded?.["wp:featuredmedia"]?.[0]?.media_details?.sizes?.full
      ?.source_url ||
    odsjek?._embedded?.["wp:featuredmedia"]?.[0]?.source_url ||
    "";

  return (
    <main role="main">
      <div
        className="row hoverStyle oodsjekDetalj"
        style={{
          backgroundImage: backgroundImageUrl
            ? `url(${backgroundImageUrl})`
            : "none",
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        <div className="col drugi odsjekDetalj">
          <div className="card upisFront">
            <div className="card-body">
              <h1 className="card-title">{naslov ? parse(naslov) : ""}</h1>
              <div>{parse(opis, prikaziOpis)}</div>
            </div>
          </div>
        </div>
      </div>
    </main>
  );
};

export default OdsijekDetalj;
